export const validatePhone = str => {
    if (!str) return '请输入手机号';
    if (str.length !== 11) return '请输入正确的手机号';
};
